// Where "Try Again" on the verification-timeout page goes (#111).
//
// An upload timeout (scanning, or the OCR-extract call during the front upload) retries the
// upload it interrupted, as before. A timeout on the Verifying screen retries, in flow order,
// the first captured side that has no result yet (anything but Pass or Fail); only when every
// side has one, the first side that is not Pass. A rejection is shown only once both sides
// have their results, so the side still missing one goes first. Retrying the last side
// instead loops when an earlier side never finished (its verify call is not awaited, so a
// lost request leaves it Pending for good).
const VERIFYING_SIDES = [
  { status: "myKadFront", step: "mykad-front-guideline" },
  { status: "myKadBack", step: "mykad-back-guideline" },
  { status: "selfieWithMyKad", step: "selfie-with-mykad-guideline", enabledBy: "Selfie With MyKad" },
  { status: "hologramDetection", step: "hologram-detection-guideline", enabledBy: "Hologram Detection" },
];

export function timeoutRetryStep({ cause, uploadRetryStep, progressStates, workflowConfig }) {
  const defaultStep = uploadRetryStep || "mykad-front-guideline";
  if (cause !== "verifying") return defaultStep;

  const sides = VERIFYING_SIDES.filter(
    (side) => !side.enabledBy || workflowConfig?.[side.enabledBy]
  );
  const statusOf = (side) => progressStates?.[side.status];
  const retry =
    sides.find((side) => !["Pass", "Fail"].includes(statusOf(side))) ||
    sides.find((side) => statusOf(side) !== "Pass");
  return retry ? retry.step : defaultStep;
}
